import { creditcardAliasApis } from '../services/creditcard-alias.api'

export function useCreditCardAlias() {
    const getCreditCardAlias = async ({ userCountry, country2Alpha, token }: { userCountry: string; country2Alpha: string; token: string }) => {
        const response = await creditcardAliasApis.getSavedCreditCards({ userCountry, country2Alpha, token })
        return response.data
    }

    const deleteCreditCardAlias = async ({
        cardAlias,
        userCountry,
        token,
        country2Alpha
    }: {
        cardAlias: string
        userCountry: string
        token: string
        country2Alpha: string
    }) => {
        const response = await creditcardAliasApis.deleteSavedCreditCard({ cardAlias, userCountry, token, country2Alpha })
        return response.data
    }

    const saveCreditCardAlias = async ({
        methodDetails,
        userCountry,
        token,
        country2Alpha
    }: {
        methodDetails: Record<string, unknown>
        userCountry: string
        token: string
        country2Alpha: string
    }) => {
        const response = await creditcardAliasApis.saveCreditCard({ methodDetails, userCountry, token, country2Alpha })
        return response.data
    }

    const getRemainingTime = async ({ token }: { token: string }) => {
        const response = await creditcardAliasApis.getRemainingTime({ token })
        return response.data
    }

    return {
        getCreditCardAlias,
        deleteCreditCardAlias,
        saveCreditCardAlias,
        getRemainingTime
    }
}
